import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import TripadvancePaymentTable from "components/tripadvancepayment/TripadvancePaymentTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import TripadvancePaymentServices from "services/TripadvancePaymentServices";

import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";

import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";

const TripadvancePayment = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const [tripadvancepaymentData, setTripadvancePaymentData] = useState([]);
  const [status, setStatus] = useState(false);
  const [error, setError] = useState(false);
  const [exportingData, setExportingData] = useState([]);

  const {
    tripadvancepaymentRef,
    dataTable,
    serviceData,
    handleSubmitTripadvancePayment,
    currentPage,
  } = useFilter(tripadvancepaymentData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };

  // const totalResults = groupedArray.length;

  useEffect(() => {
    const fetchTripadvancePayment = async () => {
      setLoading(true);
      // var date = {
      //   from: formattedDates.start_date,
      //   to: formattedDates.end_date,
      // };
      try {
        let response;
        if (tab === 0) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,
            type: 1,
            employee_id: id_employee,
          };

          response =
            await TripadvancePaymentServices.tripadvancepaymentRequestList(
              payload,
            );
        } else if (tab === 1) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 2,

            employee_id: id_employee,
          };
          response =
            await TripadvancePaymentServices.tripadvancepaymentRequestList(
              payload,
            );
        } else if (tab === 2) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 3,

            employee_id: id_employee,
          };
          response =
            await TripadvancePaymentServices.tripadvancepaymentRequestList(
              payload,
            );
        } else if (tab === 3) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 4,

            employee_id: id_employee,
          };
          response =
            await TripadvancePaymentServices.tripadvancepaymentRequestList(
              payload,
            );
        }
        const updatedData =
          response?.data?.map(
            ({
              id,
              agent_name,
              client_name,
              va_start_date,
              ref_no,
              vehicle_type,
              vendor_name,
              trip_advance_request,
              trip_advance_paid,
              adjust_amount,
              approval_status,
              paid_status,
              paid_remark,

              ...rest
            }) => ({
              id,
              agent_name,
              client_name,
              va_start_date,
              ref_no,
              vehicle_type,
              vendor_name,
              trip_advance_request,
              trip_advance_paid,
              adjust_amount,
              approval_status,
              paid_status,
              paid_remark,

              ...rest,
            }),
          ) || [];
        // console.log(updatedData);

        setTripadvancePaymentData(updatedData);
        setStatus(response?.status);
        setLoading(false);

        // Each grouped row now carries its per-item data as a real array of
        // objects — data.bookings (Ready to Pay, tab 1, one entry per
        // booking under a vendor) or data.requests (every other tab, one
        // entry per advance request against a booking+vendor). Flatten to
        // one export row per item instead of one row per group.

        // const finalData = (response?.data || []).flatMap((item) => {
        //   const perItem = tab === 1 ? item.bookings : item.requests;
        //   return (perItem || []).map((entry, index) => ({
        //     "SI.No": index + 1,
        //     "Reference No": tab === 1 ? entry.ref_no : item.ref_no,
        //     "Client Name": tab === 1 ? entry.client_name : item.client_name,
        //     "Start Date": tab === 1 ? entry.start_date : item.start_date,
        //     "End Date": tab === 1 ? entry.end_date : item.end_date,
        //     "Arrival City": tab === 1 ? entry.arrival : item.arrival,
        //     "Departure City": tab === 1 ? entry.departure : item.departure,
        //     "No.of days": tab === 1 ? entry.no_of_days : item.no_of_days,
        //     Vendor: item.vendor_name || "-",
        //     "Trip Advance Request": entry.trip_advance_request ?? "-",
        //     "Payable Amount": entry.trip_advance_amount ?? "-",
        //     Status: entry.paid_status ?? item.paid_status,
        //   }));
        // });

        // const finalData = (response?.data || []).flatMap((item) => {
        //   const perItem = tab === 1 ? item.bookings : item.requests;

        //   return (perItem || []).map((entry, index) => {
        //     const paymentHistory = (entry.payment_history || [])
        //       .map((payment, i) => {
        //         const adjustments = (payment.adjustments || [])
        //           .map(
        //             (adjustment) =>
        //               `   - Ref No: ${adjustment.ref_no || "-"}, ` +
        //               `Client: ${adjustment.client_name || "-"}, ` +
        //               `Adjusted Amount: ${adjustment.adjusted_amount || 0}`,
        //           )
        //           .join("\n");

        //         return (
        //           `Payment ${i + 1}:\n` +
        //           `   Payment Type: ${payment.payment_type || "-"}\n` +
        //           `   Amount: ₹${payment.amount || 0}\n` +
        //           `   Pending Before: ₹${payment.pending_before || 0}\n` +
        //           `   Running Balance: ₹${payment.running_balance || 0}\n` +
        //           `   UTR: ${payment.utr || "-"}\n` +
        //           `   Paid Date: ${
        //             payment.paid_date
        //               ? new Date(payment.paid_date).toLocaleDateString("en-GB")
        //               : "-"
        //           }\n` +
        //           `   Adjustments:\n${adjustments || "   - None"}`
        //         );
        //       })
        //       .join("\n\n");

        //     return {
        //       "SI.No": index + 1,
        //       "Reference No": tab === 1 ? entry.ref_no : item.ref_no,
        //       "Client Name": tab === 1 ? entry.client_name : item.client_name,
        //       "Start Date": tab === 1 ? entry.start_date : item.start_date,
        //       "End Date": tab === 1 ? entry.end_date : item.end_date,
        //       "Arrival City": tab === 1 ? entry.arrival : item.arrival,
        //       "Departure City": tab === 1 ? entry.departure : item.departure,
        //       "No.of days": tab === 1 ? entry.no_of_days : item.no_of_days,
        //       Vendor: item.vendor_name || "-",
        //       "Trip Advance Request": entry.trip_advance_request ?? "-",
        //       "Payable Amount": entry.trip_advance_amount ?? "-",
        //       "Payment History": paymentHistory || "-",
        //       Status: entry.paid_status ?? item.paid_status,
        //     };
        //   });
        // });

        const formatValue = (value) => {
          if (value === null || value === undefined || value === "") {
            return "-";
          }

          if (typeof value === "boolean") {
            return value ? "Yes" : "No";
          }

          if (Array.isArray(value)) {
            return value.length ? value.map(formatValue).join(", ") : "-";
          }

          if (typeof value === "object") {
            return JSON.stringify(value);
          }

          return value;
        };

        const formatDate = (date) => {
          if (!date) return "-";

          if (/^\d{2}-\d{2}-\d{4}$/.test(String(date))) {
            return date;
          }

          const parsedDate = new Date(date);

          return Number.isNaN(parsedDate.getTime())
            ? String(date)
            : parsedDate.toLocaleDateString("en-GB");
        };

        const formatHistory = (history = []) => {
          if (!Array.isArray(history) || history.length === 0) return "-";

          return history
            .map((payment, index) => {
              const details = Object.entries(payment)
                .filter(([key]) => key !== "adjustments")
                .map(([key, value]) => {
                  const formatted =
                    key === "paid_date"
                      ? formatDate(value)
                      : formatValue(value);

                  return `${key}: ${formatted}`;
                });

              const adjustments = (payment.adjustments || [])
                .map((adjustment, adjustmentIndex) => {
                  const fields = Object.entries(adjustment)
                    .map(([key, value]) => `${key}: ${formatValue(value)}`)
                    .join(", ");

                  return `Adjustment ${adjustmentIndex + 1}: ${fields}`;
                })
                .join("\n");

              return [
                `Payment ${index + 1}`,
                ...details,
                `Adjustments: ${adjustments || "None"}`,
              ].join("\n");
            })
            .join("\n\n");
        };

        let serialNo = 1;

        const finalData = (response?.data || []).flatMap((item) => {
          const entries = Array.isArray(item.requests) ? item.requests : [];
          const rows = entries.length ? entries : [null];

          return rows.map((entry) => {
            const row = {
              // Booking details
              "SI.No": serialNo++,
              "Booking ID": formatValue(item.ref_no),
              "Client Name": formatValue(item.client_name),
              "No. of Days": formatValue(item.no_of_days),
              "Start Date": formatDate(item.start_date),
              "End Date": formatDate(item.end_date),
              "Arrival City": formatValue(item.arrival),
              "Departure City": formatValue(item.departure),
              "Vehicle Type": formatValue(item.vehicle_type),
              "Vendor Name": formatValue(item.vendor_name),
              "Trip Is Over": formatValue(item.is_over),
              "Approval Status": formatValue(item.approval_status),
              "Booking Paid Status": formatValue(item.paid_status),
              "Payment Date": formatDate(item.payment_date),
              "Adjust Amount": formatValue(item.adjust_amount),
              "Adjusted Remark": formatValue(item.adjusted_remark),
              "Outstanding Adjust From": formatValue(
                item.outstanding_adjustfrom,
              ),
              "Outstanding Adjust From Date": formatDate(
                item.outstanding_adjustfrom_date,
              ),

              // Trip advance request details
              "Trip Advance Amount": formatValue(entry?.trip_advance_amount),
              "Amount Requested": formatValue(entry?.amount_requested),
              "Trip Advance Request": formatValue(entry?.trip_advance_request),
              "Trip Advance Paid": formatValue(entry?.trip_advance_paid),
              "Amount Paid": formatValue(entry?.amount_paid),
              "Amount Payable": formatValue(entry?.amount_payable),
              "Amount From Outstanding": formatValue(
                entry?.amount_from_outstanding,
              ),
              "Trip Went Or Not":
                entry?.trip_went_or_not === "1" || entry?.trip_went_or_not === 1
                  ? "Went"
                  : entry?.trip_went_or_not === "0" ||
                      entry?.trip_went_or_not === 0
                    ? "Not Went"
                    : "-",
              "Payable Reason": formatValue(entry?.not_payable_reason),
              "Request Paid Date": formatDate(entry?.paid_date),
              "Payment Type": formatValue(entry?.payment_type),
              UTR: formatValue(entry?.utr),
              "Paid Remark": formatValue(entry?.paid_remark),

              // Payment histories
              "Payment History": formatHistory(entry?.payment_history),
              "Actual History": formatHistory(item.actual_history),
            };

            return row;
          });
        });

        setExportingData(finalData);
      } catch (error) {
        setLoading(false);
        setError(true);
        console.error("Error fetching tripadvancepayment:", error);

        // notifyError("Failed to fetch tripadvancepayment. Please try again later.");
      }
    };
    fetchTripadvancePayment();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "trip advance payment" && perm.view === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "trip advance payment" && perm.edit === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "trip advance payment" && perm.export === 1,
      );

  const getTabName = () => {
    if (tab === 0) return "Unpaid";
    if (tab === 1) return "Ready_To_Pay";
    if (tab === 2) return "Paid";
    if (tab === 3) return "All";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="From" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="To" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={tripadvancepaymentRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitTripadvancePayment}
                  />
                </div>
                {hideExport && (
                  <ExportDataXlsx
                    title="Trip Advance List"
                    fileNames={`TripAdvancePayment_${getTabName()}`}
                    exportDataXlsx={exportingData}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}
                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unpaid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Ready To Pay"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Paid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
                      {tab !== 1 && (
                        <tr>
                          <TableCell>Sl.No.</TableCell>
                          <TableCell>Ref. No. </TableCell>
                          <TableCell>Client Name</TableCell>
                          <TableCell>Travel Date</TableCell>
                          <TableCell>Arrival / Departure</TableCell>
                          <TableCell>No. of Days</TableCell>
                          <TableCell>Vendor</TableCell>
                          {/* <TableCell>Requested Amount</TableCell>
													<TableCell>Amount Paid</TableCell>
													<TableCell>Payable</TableCell>
													<TableCell>Action</TableCell> */}
                          <TableCell
                            colSpan={4}
                            className="p-0 align-middle"
                            style={{
                              minWidth: "520px",
                              width: "520px",
                            }}
                          >
                            <div
                              className="grid w-full"
                              style={{
                                gridTemplateColumns: "150px 140px 140px 170px",
                                minWidth: "620px",
                              }}
                            >
                              <div className="flex items-center justify-center text-center text-sm font-semibold py-2 whitespace-nowrap">
                                Requested Amount
                              </div>

                              <div className="flex items-center justify-center text-center text-sm font-semibold py-2 whitespace-nowrap">
                                Amount Paid
                              </div>

                              <div className="flex items-center justify-center text-center text-sm font-semibold py-2 whitespace-nowrap">
                                Payable
                              </div>

                              <div className="flex items-center justify-center text-center text-sm font-semibold py-2 whitespace-nowrap">
                                Action
                              </div>
                            </div>
                          </TableCell>
                        </tr>
                      )}
                      {tab === 1 && (
                        <tr>
                          <TableCell>Sl.No.</TableCell>
                          <TableCell>Vendor</TableCell>
                          <TableCell>Ref. No. </TableCell>
                          <TableCell>Client Name</TableCell>
                          <TableCell>Travel Date</TableCell>
                          <TableCell>Arrival / Departure</TableCell>
                          <TableCell>No. of Days</TableCell>
                          <TableCell>Requested Amount</TableCell>
                          <TableCell>Amount Paid</TableCell>
                          <TableCell>Payable</TableCell>
                          <TableCell>Action</TableCell>
                        </tr>
                      )}
                    </TableHeader>
                    <TripadvancePaymentTable
                      tripadvancepayment={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Tripadvance Payment." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default TripadvancePayment;
